import { useNavigator } from '@repo/toolkit/use-navigator'
import { SettingIcon } from '@repo/ui/icons'
import { useMutation } from '@tanstack/react-query'
import { toast } from 'sonner'

import { createAAKeyword } from '../../../api/aa-keywords/create-aa-keyword'
import UserNavBar from '../../../components/elements/nav-bar'
import AAKeywordForm from '../../../components/pages/aa-keyword/aa-keyword-form'
import { Paths } from '../../../lib/constants/path'
import { twoButtonsConfig } from '../../../lib/utils/buttons-config/validation-buttons-config'
import { showAxiosError } from '../../../lib/utils/functions/misc.functions'

const AAKeywordCreatePage = () => {
  const { navigate, back } = useNavigator()

  const { mutateAsync } = useMutation({
    mutationFn: createAAKeyword,
    onError: showAxiosError,
    onSuccess: () => toast.success('AA créé avec succès')
  })

  return (
    <div>
      <UserNavBar title={'Créer AA'} icon={SettingIcon} />
      <div className={'h-4'} />
      <AAKeywordForm
        buttonsConfig={twoButtonsConfig({
          onConfirm: async (values) => {
            const res = await mutateAsync(values)
            navigate(Paths.AA_KEYWORD_UPDATE_PAGE.replace(':id', res.id.toString()), {
              replace: true
            })
          },
          onCancel: () => back(Paths.AA_KEYWORD_LIST_PAGE)
        })}
      />
    </div>
  )
}

export default AAKeywordCreatePage
